import { useMemo } from 'react'
import { Link, useParams } from 'react-router-dom'
import { passById } from '../data/passes'
import { resortById } from '../data/resorts'
import { PassChip } from '../components/PassChip'
import { decodePayload, type SeasonCardPayload } from '../lib/share'
import { formatMoney } from '../lib/roi'

function BrandMark() {
  return (
    <span className="brand-mark" aria-hidden>
      <svg viewBox="0 0 24 24" fill="none">
        <path d="M3 18 L10 6 l3.5 5.5 L16 9 l5 9 H3z" fill="url(#bm2)" opacity="0.95" />
        <circle cx="18" cy="5" r="2" fill="#5EC4E8" />
        <defs>
          <linearGradient id="bm2" x1="3" y1="18" x2="21" y2="5" gradientUnits="userSpaceOnUse">
            <stop stopColor="#1F8BB8" />
            <stop offset="0.5" stopColor="#2A9D8F" />
            <stop offset="1" stopColor="#5EC4E8" />
          </linearGradient>
        </defs>
      </svg>
    </span>
  )
}

export function SeasonPublic() {
  const { token } = useParams()
  const data = useMemo(
    () => (token ? decodePayload<SeasonCardPayload>(token) : null),
    [token],
  )

  if (!data || data.v !== 1) {
    return (
      <div className="app-shell">
        <div className="card">
          <h2>Season card not found</h2>
          <p className="muted">This share link looks invalid or expired.</p>
          <Link className="btn primary" to="/">
            Go to Passfolio
          </Link>
        </div>
      </div>
    )
  }

  const cpd = data.price && data.days ? data.price / data.days : null
  const visited = data.stamps.filter((s) => s.st === 'visited')
  const want = data.stamps.filter((s) => s.st === 'want')

  return (
    <div className="app-shell" style={{ paddingBottom: 40 }}>
      <div className="row between" style={{ marginBottom: 16 }}>
        <Link to="/" className="brand">
          <BrandMark />
          <span>Passfolio</span>
        </Link>
        <Link className="btn sm primary" to="/">
          Make yours
        </Link>
      </div>
      <div className="season-card-preview">
        <div className="kicker">Passfolio · {data.s}</div>
        <h1>{data.n}</h1>
        <div className="row">
          <PassChip id={data.p} />
          <span className="muted" style={{ fontSize: 13 }}>
            {passById(data.p).label}
          </span>
        </div>
        <div className="metric-grid" style={{ marginTop: 18 }}>
          <div className="metric">
            <div className="label">Visited</div>
            <div className="value" style={{ color: 'var(--good)' }}>{visited.length}</div>
          </div>
          <div className="metric">
            <div className="label">Wishlist</div>
            <div className="value" style={{ color: 'var(--want)' }}>{want.length}</div>
          </div>
          <div className="metric">
            <div className="label">Days</div>
            <div className="value">{data.days}</div>
          </div>
          <div className="metric">
            <div className="label">$/day</div>
            <div className="value" style={{ color: 'var(--accent)' }}>
              {cpd ? formatMoney(cpd) : '—'}
            </div>
          </div>
        </div>
        <div style={{ marginTop: 20 }} className="stack">
          <div>
            <div className="kicker">Mountains skied</div>
            <div className="row" style={{ marginTop: 8 }}>
              {visited.map((s) => (
                <span className="chip" key={s.id} style={{ borderColor: 'rgba(94,255,194,0.3)' }}>
                  {resortById(s.id)?.name ?? s.id}
                  {s.d ? ` · ${s.d}` : ''}
                </span>
              ))}
              {visited.length === 0 && <span className="muted">None yet</span>}
            </div>
          </div>
          <div>
            <div className="kicker">Want to go</div>
            <div className="row" style={{ marginTop: 8 }}>
              {want.map((s) => (
                <span className="chip" key={s.id} style={{ borderColor: 'rgba(255,213,106,0.35)' }}>
                  {resortById(s.id)?.name ?? s.id}
                  {s.d ? ` · ${s.d}` : ''}
                </span>
              ))}
              {want.length === 0 && <span className="muted">None yet</span>}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
